import * as channelRoutines from '../Containers/Channels/channelRoutines';
import * as momentRoutines from '../Containers/Moments/momentRoutines';
import * as notificationRoutines from '../Containers/Notifications/notificationsRoutines';
import * as rootSelectors from '../selectors/root';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { resetChannelSync, resetMessageSync } from '../Containers/Channels/sagas/';
import { resetMomentsConfigSync } from '../Containers/Moments/sagas/config';
import { resetMomentsSync } from '../Containers/Moments/sagas/data';
import { resetNotificationsSync } from '../Containers/Notifications/sagas';
import { resetProfileSync } from '../Containers/Profile/profileSagas';
import { resetScheduleSync } from '../Containers/Schedule/scheduleSagas';

import * as alertUserRoutines from '../Containers/AlertUser/routines';
import * as discoverRoutines from '../Containers/Discover/discoverRoutines';
import * as eventRoutines from '../Containers/Events/eventRoutines';
import * as ui_actionTypes from '../redux/ui/actionTypes';
import { bootstrapEvent } from '../redux/ui/actions';
import { fetchActiveModulesSaga, fetchEventInformationFromFBSaga } from '../Containers/Events/sagas/events';
import { fetchGroups, resetUserSync } from '../sagas/users';
import { resetUserInfoSync } from '../sagas/userInfo';

import { resetDiscoverSync } from '../Containers/Discover/discoverSagas';
import {resetPeerToPeerStatusSync} from "../Containers/Dashboard/sagas";

export function* eventWideDataSync() {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    yield put(channelRoutines.clearChannelData());
    yield put(channelRoutines.clearChannelMessagesData());
    yield put(momentRoutines.clearMomentsData());
    yield put(alertUserRoutines.clearAlertUserData());
    yield put(notificationRoutines.clearNotificationsData());
    yield put(discoverRoutines.clearDiscoverData());
    yield put(eventRoutines.clearSitePagesData());
    yield call(fetchEventInformationFromFBSaga, activeEvent);
    yield put(alertUserRoutines.fetchAlertUser());
    yield put(eventRoutines.clearInviteesData());
    yield put(eventRoutines.fetchEventInviteesCounts());
    yield put(eventRoutines.fetchSitePagesForEvent());
    yield call(resetChannelSync);
    yield call(resetPeerToPeerStatusSync); //Listens for whether PeerToPeer is enabled or not
    yield call(resetProfileSync);
    yield call(resetScheduleSync);
    yield call(resetMomentsConfigSync);
    yield call(resetMessageSync);
    yield call(resetMomentsSync);
    yield call(resetDiscoverSync);
    yield call(resetUserSync);
    yield call(resetUserInfoSync);

    yield call(fetchGroups);
    yield call(resetNotificationsSync);
    yield call(fetchActiveModulesSaga);
    yield put(bootstrapEvent.success());
}


export default function* rootEventWideWatcher() {
    yield takeLatest(ui_actionTypes.SET_ACTIVE_EVENT, eventWideDataSync);
}
